import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../store';
import {
    BsCheckCircleFill,
    BsFillExclamationCircleFill,
    BsFillExclamationTriangleFill,
    BsInfoCircleFill
} from 'react-icons/bs';
import { toasterRemove } from '../redux/toasterSlice';

const Alert: React.FC = () => {
    const toaster = useSelector((state: RootState) => state.alert.toaster);
    const [list, setList] = useState(toaster);
    const [exitingIds, setExitingIds] = useState<Set<string | number>>(new Set());
    const dispatch = useDispatch();

    useEffect(() => {
        if (toaster.length) {
            setList([...toaster]);
        }
    }, [toaster]);

    const deleteToast = (id: string | number) => {
        const updatedList = list.filter(e => e.id !== id);
        dispatch(toasterRemove(id));
        setList(updatedList);
        setExitingIds(prev => {
            const next = new Set(prev);
            next.delete(id);
            return next;
        });
    };

    const startExit = (id: string | number) => {
        setExitingIds(prev => new Set(prev).add(id));
        setTimeout(() => deleteToast(id), 300);
    };

    useEffect(() => {
        const interval = setInterval(() => {
            if (toaster.length && list.length) {
                const firstId = toaster[0]?.id;
                if (firstId != null) {
                    startExit(firstId);
                }
            }
        }, 3000);

        return () => {
            clearInterval(interval);
        };
    }, [toaster, list]);

    const getToastStyle = (type: string) => {
        switch (type) {
            case 'success':
                return { bgColor: '#5cb85c', icon: <BsCheckCircleFill /> };
            case 'error':
                return { bgColor: '#d9534f', icon: <BsFillExclamationCircleFill /> };
            case 'warning':
                return { bgColor: '#f0ad4e', icon: <BsFillExclamationTriangleFill /> };
            case 'info':
                return { bgColor: '#5bc0de', icon: <BsInfoCircleFill /> };
            default:
                return { bgColor: '#5cb85c', icon: <BsCheckCircleFill /> };
        }
    };

    return (
        <div className={'notification-container top-right'}>
            {list !== undefined &&
                list.map((toast: any, key) => {
                    const { bgColor, icon } = getToastStyle(toast.type);
                    return (
                        <div
                            key={`toast_${key}`}
                            className={`notification toast top-right${exitingIds.has(toast.id) ? ' is-leaving' : ''}`}
                            style={{ backgroundColor: bgColor }}
                        >
                            <button onClick={() => { if (toast.id != null) { startExit(toast.id); } }}>X</button>
                            <div className="d-flex">
                                <div className="notification-image">{icon}</div>
                                <div>
                                    <p className="notification-title">{toast.title}</p>
                                    <p className="notification-message">{toast.message}</p>
                                </div>
                            </div>
                        </div>
                    );
                })}
        </div>
    );
};

export default Alert;
